/**
*
* SideDrawer
*
*/

import React from 'react';
import PropTypes from 'prop-types';

import { PageWrapper } from 'components/PageStyles';
import { Transition } from 'react-transition-group';

import { Wrapper, ModalArea, Overlay, Drawer } from './styles';

const SideDrawer = ({
  isOpen,
  close,
  onOpen,
  children,
  positionFromLeft,
  positionFromRight,
  positionFromTop,
  lightBackground,
  drawerWidth,
  zIndex = "1",
  showOverlay = true,
}) => (
  <Transition
    in={isOpen}
    timeout={{ enter: 0, exit: 500 }}
    onEntered={onOpen}
    unmountOnExit
    mountOnEnter
  >
    {(status) => (
      <Drawer
        zIndex={zIndex}
        drawerWidth={drawerWidth}
        positionFromLeft={positionFromLeft}
        positionFromRight={positionFromRight}
        positionFromTop={positionFromTop}
      >
        <PageWrapper>
          <Wrapper>
            {showOverlay &&
              <Overlay
                status={status}
                onClick={close}
              />
            }
            <ModalArea
              status={status}
              drawerWidth={drawerWidth}
              positionFromRight={positionFromRight}
              lightBackground={lightBackground}
            >
              {children}
            </ModalArea>
          </Wrapper>
        </PageWrapper>
      </Drawer>
    )}
  </Transition>
);

SideDrawer.propTypes = {
  isOpen: PropTypes.bool,
  close: PropTypes.func,
  onOpen: PropTypes.func,
  children: PropTypes.node,
  drawerWidth: PropTypes.string,
  positionFromLeft: PropTypes.string,
  positionFromRight: PropTypes.string,
  positionFromTop: PropTypes.string,
  lightBackground: PropTypes.string,
  showOverlay: PropTypes.bool,
};

export default SideDrawer;
